import React from 'react';
import '../styles/WhyTeamsLove.css';

const WhyTeamsLove: React.FC = () => {
  const features = [
    {
      title: "Always On - 24/7 Efficiency",
      description: "AI works continuously, cutting supplier search and quote turnaround from 2–3 weeks to under 48 hours"
    },
    {
      title: "Cost Savings - Continuous Spend Reduction",
      description: "Typically identifies 5–15% savings in sourcing costs in recurrent purchases of standard parts"
    },
    {
      title: "Time Savings – Free Your Team",
      description: "Automates up to 80% of manual procurement tasks, freeing staff for strategic work"
    },
    {
      title: "Smarter Decisions – Data You Can Trust",
      description: "Side-by-side comparisons with real-time supplier intelligence increase decision confidence"
    },
    {
      title: "Innovation - Born the AI way",
      description: "Continuously improves sourcing strategies and adapts to market changes, keeping your procurement future-ready"
    },
    {
      title: "Scalability – Grows with Your Needs",
      description: "Handles multiple RFQs and categories in parallel, ensuring procurement keeps pace with business growth"
    }
  ];

  return (
    <section className="why-teams-love">
      <div className="container">
        <h2 className="section-title">Why Teams Love GordianRFQ</h2>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTeamsLove;
